import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import MetisMenu from "metismenujs";

import SimpleBar from "simplebar-react";
import {
  DropdownItem,
  DropdownMenu,
  Dropdown,
  DropdownToggle,
  Navbar,NavbarToggler,NavbarBrand,Nav,NavItem,NavLink,Container, Row, Col,Badge,
  Card, CardImg, CardText, CardBody,
  CardTitle, CardSubtitle, Button
} from "reactstrap";


class PTAMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  render() {
    const user =  sessionStorage.getItem("uname");
    const role =  sessionStorage.getItem("urole");
  
    return (
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">
                
                
            </li>
             <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="ti-user text-success"></i>
				<span className="badge badge-pill badge-success float-right">
                  Online
                </span>
                <span>{user}</span>
              </Link>
            </li>
			<hr />  
          
             <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="ti-home"></i>
                
                <span>Dashboard</span>
              </Link>
            </li>
			<li>
			  <Link to="/#" className="has-arrow waves-effect">
				<i className="ti-email"></i>
				<span>School Visit</span>
			  </Link>
			  <ul className="sub-menu" aria-expanded="false">
				<li>
				  <Link to="/inspection_visits">Inspection Visits</Link>
				</li>
				{
					/*<li>
					  <Link to="/advisory_visits"><i className="text-success"><Assignment /></i>Advisory Visits</Link>
					</li> */
				}
				
			  </ul>
			</li>
			<li>
			  <Link to="/#" className="has-arrow waves-effect">
				<i className="ti-email"></i>
				<span>Reports</span>
			  </Link>
			  <ul className="sub-menu" aria-expanded="false">
				<li>
				  <Link to="/perf_report">Performance Report</Link>
				</li>
				<li>
				  <Link to="/advisory_visits">Progress Report</Link>
				</li>
				
			  </ul>
			</li>
            <li>
              <Link to="/calendar" className=" waves-effect">
                <i className="ti-calendar"></i>
                <span>Calendar</span>
              </Link>
            </li>
    
            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ti-email"></i>
                <span>Email</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/email-inbox">Inbox</Link>
                </li>
                <li>
                  <Link to="/email-read">Email Read</Link>
                </li>
                <li>
                  <Link to="/email-compose">Email Compose</Link>
                </li>
              </ul>
             </li>
            
            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-settings-outline"></i>
                <span>System Settings</span>
              </Link>
			  {
					  /* <ul className="sub-menu" aria-expanded="false">
						<li>
						  <Link to="/users">System Users</Link>
						</li>
					  </ul> */
			  }
        </li>
            
            
          </ul>
        </div>
      );
  }
}

export default PTAMenu;
